export default __webpack_public_path__ + "static/media/mouseCursor.053eb3ca.svg";